import React, { useEffect } from 'react';
import { Layout } from '../components/Layout';

export default function FeatureRequest() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-2xl font-bold text-slate-900 mb-1">Need New Features?</h1>
        <p className="text-slate-500 mb-6 text-sm">Share your ideas and help us build the features that matter most to you.</p>
        <div
          style={{ width: '100%', height: '500px' }}
          data-fillout-id="4u5v5R4oGdus"
          data-fillout-embed-type="standard"
          data-fillout-inherit-parameters=""
          data-fillout-dynamic-resize=""
        />
      </div>
    </Layout>
  );
}
